module.exports = __webpack_public_path__ + "static/media/logo_carmera.53c956ac.png";